import { Injectable } from '@angular/core';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ClientConfigProductName, GenericListItem, LazyClientConfig, LazyClientConfigBase, LazyClientConfigService } from '@frontend/vanilla/core';

import {
    AdditionalCoordinatorSettings,
    BootstrapAssets,
    ErrorSettings,
    InstallerSettings,
    InteractiveLaunchSettings,
    NativeSettings,
    PluginLoadSettings,
    SynchronizationSettings,
} from './client-models/coordinator.models';
import { LocationInfoStatusSettings } from './client-models/location-info';

@LazyClientConfig({ key: 'vnGeoCoordinator', product: ClientConfigProductName.HOST })
@Injectable({
    providedIn: 'root',
    deps: [LazyClientConfigService],
    useFactory: geoCoordinatorConfigFactory,
})
export class GeoCoordinatorClientConfig extends LazyClientConfigBase {
    readonly textMappings: GenericListItem;
    readonly bootstrapAssets: BootstrapAssets;
    readonly additionalSettings: AdditionalCoordinatorSettings;
    readonly errorSettings: ErrorSettings;
    readonly installerSettings: InstallerSettings;
    readonly locationInfoStatus: LocationInfoStatusSettings;
    readonly synchronizationSettings: SynchronizationSettings;
    readonly interactiveLaunch: InteractiveLaunchSettings;
    readonly nativeSettings: NativeSettings;
    readonly pluginLoadSettings: PluginLoadSettings;
    readonly enableNDBS: boolean;
    readonly apiToken: string;
    readonly isEnabled: boolean;
    readonly switchOnLegacy: boolean;
}

export function geoCoordinatorConfigFactory(service: LazyClientConfigService): GeoCoordinatorClientConfig {
    return service.get(GeoCoordinatorClientConfig);
}
